import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamQuestionSchema } from './schemas';

export const LEGACY_EXAM_QUESTION_FIELDS = describeFields(LegacyExamQuestionSchema, {
  examId: {},
  questionId: {},
  creationDatetime: {},
  editDatetime: {},
  label: {},
  maxMark: {},
  type: {},
  topics: { widget: FieldWidget.Select },
  active: { widget: FieldWidget.Text },
  analytics: {},
  criteria: {},
  guides: {},
});
